(() => {
  // src/related-product-carousel.ts
  (() => {
    const initRecommendations = (scope) => {
      const root = scope || document;
      root.querySelectorAll(".related-product-carousel__recommendations-placeholder").forEach(async (el) => {
        const { sectionId, productId, limit } = el.dataset;
        const url = `/recommendations/products?section_id=${sectionId}&product_id=${productId}&limit=${limit}&intent=related`;
        try {
          const r = await fetch(url);
          if (!r.ok) return;
          const html = await r.text();
          const doc = new DOMParser().parseFromString(html, "text/html");
          const incoming = doc.querySelector(`#related-product-carousel-${sectionId}`);
          if (incoming) {
            el.closest(`#related-product-carousel-${sectionId}`).replaceWith(incoming);
          }
        } catch (e) {
        }
      });
    };
    initRecommendations();
    document.addEventListener("shopify:section:load", (e) => initRecommendations(e.target));
  })();
})();
